import React from "react";

import loadingScreen from "@assets/sales-v3-platform-loading-cell.gif";

export function LoadingIndicator() {
  return <img className="w-10" src={loadingScreen} alt="Loading screen gif" />;
}
